var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGauge = function SvgGauge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5515 45.5516C58.5515 32.5444 48.0071 22 34.9999 22C21.9927 22 11.4482 32.5444 11.4482 45.5516",
    stroke: "#DCEFFE",
    strokeWidth: 4.71033,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.1776 47.9072H19.6914C19.6914 40.225 22.7245 35.5565 27.3004 32.5986L36.1776 47.9072Z",
    fill: "url(#paint0_linear_458_42526)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4482 45.5515C11.4482 37.585 15.4036 30.5424 21.4577 26.2803",
    stroke: "#90CAF9",
    strokeWidth: 4.71033,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6044 45.254C38.1686 46.0044 37.9753 47.0762 37.1845 47.5822C36.3909 48.09 35.3328 47.8124 34.8906 46.9805L27.1844 32.4807C27.1675 32.4489 27.156 32.4145 27.1502 32.379C27.0955 32.0406 27.5308 31.8553 27.7368 32.1293L37.6044 45.254Z",
    fill: "#90CAF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_42526",
    x1: 38.051,
    y1: 33.6192,
    x2: 16.1097,
    y2: 44.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGauge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gauge.d8ab28fcabac5a3519ea36badafa9a9d.svg";